export const errorIncorrectRedeemCode = 'Sorry that code is invalid. Please try another code or **contact support**.';
export const initialState = {
  breadcrumbs: {
    name: null,
    category: null,
    numericId: 0,
  },
};
export const bundleAccessProfileProperty = 'Bundle Access';
export const nonMemorangBundleIds = [44, 45, 46, 53, 54, 55, 56, 57, 58, 59, 60];
